<template>
  <ToastProvider>
    <router-view />
  </ToastProvider>
</template>

<script lang="ts" setup>
import ToastProvider from '~/components/Toast/ToastProvider.vue'
</script>
